import type { ButtonProps } from '@mui/material/Button';
import type { ConfirmationDialogProps } from './dialog';

import ConfirmationDialog from './dialog';
import { TrackedButton } from '@blueshift-ui/analytics';
import { useState } from 'react';

interface ConfirmationDialogTriggerProps {
  buttonProps?: ButtonProps & { id: string };
  dialogProps: Omit<ConfirmationDialogProps, 'open'>;
  onCancel?: () => void;
}

function ConfirmationDialogTrigger({
  buttonProps,
  dialogProps,
  onCancel,
}: ConfirmationDialogTriggerProps) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  function handleTriggerClick(event: React.MouseEvent<HTMLButtonElement>) {
    setIsDialogOpen(true);
    buttonProps?.onClick?.(event);
  }

  function handleDialogClose() {
    onCancel?.();
    setIsDialogOpen(false);
  }

  return (
    <>
      <TrackedButton onClick={handleTriggerClick} {...buttonProps} />
      <ConfirmationDialog
        onCancel={handleDialogClose}
        onClose={handleDialogClose}
        open={isDialogOpen}
        {...dialogProps}
      />
    </>
  );
}

export default ConfirmationDialogTrigger;
